import React, { useState } from 'react';

function SecurityChecklist() {
  const [checked, setChecked] = useState([]);

  const items = [
    {
      id: 1,
      title: 'Операции соответствуют виду деятельности',
      description: 'Платежи и поступления должны соответствовать ОКВЭД вашей компании. Если вы продаёте мебель, а получаете платежи за «консалтинг» — это подозрительно.',
      critical: true,
    },
    {
      id: 2,
      title: 'Нет дробления платежей',
      description: 'Разбивка крупной суммы на несколько мелких платежей (например, 600 000 ₽ на 3 платежа по 199 000 ₽) — признак дробления. Банк может заблокировать счёт.',
      critical: true,
    },
    {
      id: 3,
      title: 'Контрагенты проверены',
      description: 'Перед сделкой проверяйте контрагента: нет ли его в реестре недобросовестных, нет ли массового адреса или директора.',
      critical: true,
    },
    {
      id: 4,
      title: 'Налоги уплачиваются в срок',
      description: 'Задолженность по налогам — один из признаков для блокировки. Следите за налоговым календарём.',
      critical: true,
    },
    {
      id: 5,
      title: 'Нет транзитных операций',
      description: 'Если деньги приходят и сразу уходят на другие счета без экономического смысла — это транзит. Банк заблокирует.',
      critical: true,
    },
    {
      id: 6,
      title: 'Снятие наличных — обосновано',
      description: 'Регулярное снятие крупных сумм наличными (особенно в день поступления) — признак обналичивания.',
      critical: false,
    },
    {
      id: 7,
      title: 'Зарплата выплачивается официально',
      description: 'Если сотрудники получают зарплату на карты, а в отчётности — минимальная сумма, это риск.',
      critical: false,
    },
    {
      id: 8,
      title: 'Внешнеэкономические операции — в порядке',
      description: 'Платежи в адрес иностранных компаний требуют документов. Без них — блокировка.',
      critical: false,
    },
  ];

  const toggleCheck = (id) => {
    setChecked(prev => prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]);
  };

  const progress = Math.round((checked.length / items.length) * 100);

  const getProgressColor = () => {
    if (progress >= 80) return '#10B981';
    if (progress >= 50) return '#F59E0B';
    return '#EF4444';
  };

  const downloadChecklist = () => {
    const text = `ЧЕК-ЛИСТ БЕЗОПАСНОСТИ СЧЁТА (115-ФЗ)
Дата: ${new Date().toLocaleString('ru-RU')}

${items.map(item => `${checked.includes(item.id) ? '✅' : '⬜'} ${item.title}\n   ${item.description}`).join('\n\n')}

Прогресс: ${progress}% (${checked.length} из ${items.length})

Рекомендации:
1. Проверяйте контрагентов перед сделкой через Khepri
2. Следите за налоговым календарём
3. Не допускайте дробления платежей
4. Храните документы по всем операциям

Отчёт сгенерирован Khepri
`;
    const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Безопасность_счёта_Khepri.txt';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <div>
      <h2 style={{ color: '#F7DE8A' }}>🛡️ Безопасность счёта (115-ФЗ)</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 16 }}>
        Проверьте свой бизнес на признаки блокировки счёта банком
      </p>

      {/* Прогресс */}
      <div style={{ marginBottom: 20, padding: 16, background: '#1E293B', borderRadius: 12, border: '1px solid #8A6636' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
          <span style={{ color: '#F7DE8A', fontWeight: 600 }}>Прогресс проверки</span>
          <span style={{ color: getProgressColor(), fontWeight: 700, fontSize: 20 }}>{progress}%</span>
        </div>
        <div style={{ height: 12, background: '#0F172A', borderRadius: 6, overflow: 'hidden' }}>
          <div style={{ width: `${progress}%`, height: '100%', background: getProgressColor(), borderRadius: 6, transition: 'width 0.3s' }} />
        </div>
        <div style={{ marginTop: 8, fontSize: 12, color: '#94A3B8' }}>
          Отмечено {checked.length} из {items.length} пунктов
        </div>
      </div>

      {/* Предупреждение */}
      {progress < 50 && (
        <div style={{ marginBottom: 20, padding: 16, background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 12 }}>
          <strong style={{ color: '#EF4444' }}>⚠️ Высокий риск блокировки счёта</strong>
          <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4 }}>
            Пройдите все пункты чек-листа, чтобы снизить риск. Банк может заблокировать счёт при выявлении признаков 115-ФЗ.
          </p>
        </div>
      )}

      {progress >= 80 && (
        <div style={{ marginBottom: 20, padding: 16, background: 'rgba(16,185,129,0.15)', border: '1px solid rgba(16,185,129,0.3)', borderRadius: 12 }}>
          <strong style={{ color: '#10B981' }}>✅ Низкий риск блокировки</strong>
          <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4 }}>
            Ваш бизнес соответствует требованиям 115-ФЗ. Продолжайте следить за операциями.
          </p>
        </div>
      )}

      {/* Чек-лист */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 20 }}>
        {items.map(item => {
          const isChecked = checked.includes(item.id);
          return (
            <div
              key={item.id}
              onClick={() => toggleCheck(item.id)}
              style={{
                padding: 16,
                background: '#1E293B',
                borderRadius: 12,
                border: isChecked ? '2px solid #10B981' : '1px solid #8A6636',
                cursor: 'pointer',
                transition: 'all 0.2s',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                <div style={{
                  width: 24,
                  height: 24,
                  borderRadius: 6,
                  background: isChecked ? '#10B981' : '#0F172A',
                  border: isChecked ? 'none' : '1px solid #8A6636',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  marginTop: 2,
                }}>
                  {isChecked && <span style={{ color: '#fff', fontWeight: 700 }}>✓</span>}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                    <span style={{ color: '#F8FAFC', fontWeight: 600, fontSize: 14 }}>{item.title}</span>
                    {item.critical && (
                      <span style={{ fontSize: 10, background: '#EF4444', color: '#fff', padding: '2px 6px', borderRadius: 4, fontWeight: 700 }}>
                        КРИТИЧНО
                      </span>
                    )}
                  </div>
                  <div style={{ color: '#94A3B8', fontSize: 13, lineHeight: 1.5 }}>
                    {item.description}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Кнопка скачивания */}
      <button
        onClick={downloadChecklist}
        style={{
          padding: '12px 24px',
          background: '#F7DE8A',
          color: '#0F172A',
          border: 'none',
          borderRadius: 8,
          cursor: 'pointer',
          fontWeight: 700,
          fontSize: 14,
        }}
      >
        📥 Скачать чек-лист
      </button>

      {/* Справка */}
      <div style={{ marginTop: 24, padding: 16, background: '#1E293B', borderRadius: 12, border: '1px solid #8A6636' }}>
        <h3 style={{ color: '#F7DE8A', marginBottom: 8, fontSize: 15 }}>📚 Что делать, если счёт заблокирован</h3>
        <ol style={{ color: '#94A3B8', fontSize: 13, paddingLeft: 20, lineHeight: 1.7 }}>
          <li>Узнайте причину блокировки в банке (запрос в письменной форме)</li>
          <li>Предоставьте документы по операциям (договоры, счета, акты)</li>
          <li>Напишите пояснение в банк и Росфинмониторинг</li>
          <li>Если блокировка незаконна — обратитесь в ЦБ РФ или суд</li>
        </ol>
        <p style={{ color: '#94A3B8', fontSize: 12, marginTop: 12 }}>
          ⚠️ Демо-режим. Чек-лист носит рекомендательный характер. Для юридической консультации обратитесь к юристу.
        </p>
      </div>
    </div>
  );
}

export default SecurityChecklist;